export const configurationValueModel = (data = {}) => ({
    uuid: data.uuid || '',
    value: data.value ?? '',
    isActive: Boolean(data.is_active),
});

export const configurationModel = (data = {}) => ({
    uuid: data.uuid || '',
    key: data.key || '',
    number: data.number ?? null,
    keyValueType: data.key_value_type ?? null,
    keyValueHint: data.key_value_hint || '',
    isActive: Boolean(data.is_active),
    values: (data.values || []).map(configurationValueModel),
    createdAt: data.created_at || '',
    updatedAt: data.updated_at || '',
});
